import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-consultancy-requests.tsx
var LazyConsultancyRequests = lazy(() => import("./consultancy-requests-C3qYKtnk.js").then((n) => n.n).then((module) => ({ default: module.ConsultancyRequests })));
function ConsultancyRequests({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultancy-requests" }),
		children: /* @__PURE__ */ jsx(LazyConsultancyRequests, { ...props })
	});
}
function ConsultancyRequestsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultancy-requests" }),
		children: /* @__PURE__ */ jsx(LazyConsultancyRequests, { ...props })
	});
}
var useConsultancyRequestsContent = () => {
	return useMemo(() => ({ consultancyRequests: { component: ConsultancyRequestsContent } }), []);
};
//#endregion
export { ConsultancyRequests, useConsultancyRequestsContent };
